<template>
  <div class="payment-vault">
    <section class="hero is-small is-primary top-section">
      <div class="hero-body">
        <div class="columns is-centered">
          <div class="column is-three-quarters">
            <div class="content">
              <h1 class="title has-text-white">Kolibri Payment Vaults</h1>

              <div v-if="!addressIsValid" class="box no-vault">
                <p class="title is-4 has-text-centered">Invalid vault address {{ vaultAddress }}!</p>
              </div>
              <PaymentVaultInfo v-else :contract-address="vaultAddress" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PaymentVaultInfo from "@/components/PaymentVaultInfo";
export default {
  name: 'PaymentVaultSingle',
  components: {PaymentVaultInfo},
  async mounted(){},
  data(){
    return {
    }
  },
  methods:{

  },
  computed: {
    addressIsValid(){
      return !!this.vaultAddress.match(/^KT1[a-zA-Z0-9]{33}/)
    },
    vaultAddress(){
      return this.$route.params.vaultAddress
    }
  },
  watch: {
  }
}
</script>

<style lang="scss">
@import '../assets/sass/globals';
.payment-vault{
  .no-vault{
    min-height: 10rem;
    display: flex;
    align-items: center;
    justify-content: center;
    .title{
      color: $grey-dark !important;
    }
  }
  .hero{
    min-height: 100vh;
    .title{
      display: flex;
      align-items: flex-end;
      justify-content: center;
      span.help{
        margin-bottom: 3px;
        margin-left: 3px;
      }
    }
  }
  .loader-wrapper{
    padding: 1rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
